import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { EllipsisIcon, FileDownIcon, Share2Icon, Trash2Icon } from 'lucide-react';

type DropdownMediaButtonsProps = {
  type: 'estate' | 'project';
  canWriteMedia?: boolean;
  onDelete?: () => void;
  onShare?: () => void;
  onDownload?: () => void;
  onChooseThumbnail?: () => void;
};

export const DropdownMediaButtons = ({
  type = 'estate',
  canWriteMedia = true,
  onDelete,
  onShare,
  onDownload,
  onChooseThumbnail,
}: DropdownMediaButtonsProps) => {
  const [isVisibleButtons, setVisibleButtons] = useState(false);
  const { t } = useTranslation();

  const handleSetVisible = () => setVisibleButtons((prev) => !prev);
  return (
    <div className="max-lg:flex max-lg:justify-end xl:hidden">
      <DropdownMenuPrimitive.DropdownMenu open={isVisibleButtons} onOpenChange={handleSetVisible}>
        <DropdownMenuPrimitive.DropdownMenuTrigger className="flex h-full items-center text-center text-primary-light outline-none">
          <EllipsisIcon />
        </DropdownMenuPrimitive.DropdownMenuTrigger>
        <DropdownMenuPrimitive.DropdownMenuContent className="z-20 mt-2 min-w-32 rounded border border-gray-200 bg-white p-2 text-primary shadow-md">
          {canWriteMedia ? (
            <>
              <DropdownMenuPrimitive.DropdownMenuItem
                onClick={onDelete}
                className="flex cursor-pointer items-center gap-1 rounded px-2 py-1 outline-none hover:bg-primary-light hover:text-white"
              >
                <Trash2Icon />
                {t('delete')}
              </DropdownMenuPrimitive.DropdownMenuItem>

              {type === 'estate' ? (
                <DropdownMenuPrimitive.DropdownMenuItem
                  onClick={onShare}
                  className="flex cursor-pointer items-center gap-1 rounded px-2 py-1 outline-none hover:bg-primary-light hover:text-white"
                >
                  <Share2Icon />
                  {t('share')}
                </DropdownMenuPrimitive.DropdownMenuItem>
              ) : null}
            </>
          ) : null}
          <DropdownMenuPrimitive.DropdownMenuItem
            onClick={onDownload}
            className="flex cursor-pointer items-center gap-1 rounded px-2 py-1 outline-none hover:bg-primary-light hover:text-white"
          >
            <FileDownIcon />
            {t('download')}
          </DropdownMenuPrimitive.DropdownMenuItem>
          {canWriteMedia ? (
            <DropdownMenuPrimitive.DropdownMenuItem
              onClick={onChooseThumbnail}
              className="flex cursor-pointer items-center gap-1 rounded px-2 py-1 outline-none hover:bg-primary-light hover:text-white"
            >
              {t('chose-thumbnail')}
            </DropdownMenuPrimitive.DropdownMenuItem>
          ) : null}
        </DropdownMenuPrimitive.DropdownMenuContent>
      </DropdownMenuPrimitive.DropdownMenu>
    </div>
  );
};
